import Flag from '@mui/icons-material/Flag'
import SportsScore from '@mui/icons-material/SportsScore'
import dayjs from 'dayjs'
import {
  UAPActivityDetailsTitle,
  UAPDayCompletionTick,
  UAPDayContentDivider,
  UAPDayContentDividerContainer,
  UAPDayHeading,
  UAPDayHeadingContainer,
  UAPDayItemEventDetailsContainer,
  UAPDayProgressConnectorContainer,
  UAPDayThread,
  UAPTimePlanTitlesAndCheckBoxContainer,
  UserActivityPlanPhaseDayItemContainer,
} from '../../MyPlanStyles'

export function PlannedActivityStartedEndedComponent({ userActivity, startCard }) {
  return (
    <UserActivityPlanPhaseDayItemContainer noBorder={!startCard}>
      <UAPTimePlanTitlesAndCheckBoxContainer>
        <UAPDayHeadingContainer>
          <UAPDayHeading style={{ opacity: !startCard ? 0 : 1 }}>
            <span>{dayjs(userActivity?.createdTime).format('D MMM').split(' ')?.[1]}</span>
            <span>{dayjs(userActivity?.createdTime).format('D MMM').split(' ')?.[0]}</span>
          </UAPDayHeading>
        </UAPDayHeadingContainer>
        <UAPDayContentDividerContainer style={{ opacity: !startCard ? 0 : 1 }}>
          <UAPDayContentDivider />
        </UAPDayContentDividerContainer>
        <UAPDayItemEventDetailsContainer style={{ color: '#fff' }}>
          <div className="d-flex flex-column align-items-center gap-2 w-100">
            <UAPActivityDetailsTitle style={{ textAlign: 'center' }}>
              {startCard ? 'Plan Activated' : ''}
            </UAPActivityDetailsTitle>
          </div>
        </UAPDayItemEventDetailsContainer>
        <UAPDayProgressConnectorContainer>
          {startCard && (
            <>
              <UAPDayThread hide />
              <UAPDayCompletionTick>
                <Flag sx={{ color: 'green' }} />
              </UAPDayCompletionTick>
              <UAPDayThread />
            </>
          )}
          {!startCard && (
            <>
              <UAPDayThread />
              <UAPDayCompletionTick>
                <SportsScore />
              </UAPDayCompletionTick>
              <UAPDayThread hide />
            </>
          )}
        </UAPDayProgressConnectorContainer>
      </UAPTimePlanTitlesAndCheckBoxContainer>
    </UserActivityPlanPhaseDayItemContainer>
  )
}
